import APICall from './../utils/APICall';

export default class LoanServices {

    static listLoans = async (page, pageLimimt, search,startDate, endDate, loanApplicationProgressState) => {
        var url = `/api/Loan/admin/list-loan-applications?page=${page}&pageLimit=${pageLimimt}&loanType=Personal`;
        if (search) url = `${url}&search=${search}`;
        if (startDate) url = `${url}&startDate=${startDate}`;
        if (endDate) url = `${url}&endDate=${endDate}`;
        if (loanApplicationProgressState) url = `${url}&loanApplicationProgressState=${loanApplicationProgressState}`;
        return await APICall(url, "GET");
        }
        static listCashbackLoans = async (page, pageLimimt, search,startDate, endDate, loanApplicationProgressState) => {
            var url = `/api/Loan/admin/list-loan-applications?page=${page}&pageLimit=${pageLimimt}&loanType=Cashbacked`;
            if (search) url = `${url}&search=${search}`;
            if (startDate) url = `${url}&startDate=${startDate}`;
            if (endDate) url = `${url}&endDate=${endDate}`;
            if (loanApplicationProgressState) url = `${url}&loanApplicationProgressState=${loanApplicationProgressState}`;
            return await APICall(url, "GET");
            }
        static listPaydayLoans = async (page, pageLimimt, search,startDate, endDate, loanApplicationProgressState) => {
            var url = `/api/Loan/admin/list-loan-applications?page=${page}&pageLimit=${pageLimimt}&loanType=Payday`;
            if (search) url = `${url}&search=${search}`;
            if (startDate) url = `${url}&startDate=${startDate}`;
            if (endDate) url = `${url}&endDate=${endDate}`;
            if (loanApplicationProgressState) url = `${url}&loanApplicationProgressState=${loanApplicationProgressState}`;
            return await APICall(url, "GET");
        }
        static loanDetails = async (loanApplicationId ) => {
            let url = `/api/Loan/admin/view-details/${loanApplicationId}`;
            return await APICall(url, "GET");
        }
      
        static listCashbackLoans = async (page, pageLimimt, search,startDate, endDate, loanApplicationProgressState) => {
            var url = `/api/Loan/admin/list-loan-applications?page=${page}&pageLimit=${pageLimimt}&loanType=Cashbacked`;
            if (search) url = `${url}&search=${search}`;
            if (startDate) url = `${url}&startDate=${startDate}`;
            if (endDate) url = `${url}&endDate=${endDate}`;
            if (loanApplicationProgressState) url = `${url}&loanApplicationProgressState=${loanApplicationProgressState}`;
            return await APICall(url, "GET");
            }
        static loanDetails = (loanApplicationId ) => {
            let url = `/api/Loan/admin/view-details/${loanApplicationId}`;
            return APICall(url, "GET");
        }

        static ApproveRejectLoan = (payload ) => {
            let url = `/api/Loan/admin/approve-reject`;
            return APICall(url, "POST", payload);
        }
}